import { useMemo } from 'react';
import { combineAccessInputs, mapAccessInput } from '@/abilities/accessInput';
import type { RouteCondition } from '@/abilities/routeCondition';
import { useCompanyWorkspaceAccess } from '@/abilities/companyWorkspace/useCompanyWorkspaceAccess';
import { useCompanyDashboardAccess } from '@/abilities/companyDashboard/useCompanyDashboardAccess';
import { useCompanyBankFeedAccess } from '@/abilities/companyBankFeed/useCompanyBankFeedAccess';

// Any signed-in user enters a company. Its pages open once the cases their navigation lists entries by are known, so
// no entry appears after the page.
export const companyRoute: RouteCondition = function useCompanyRoute() {
  const workspace = useCompanyWorkspaceAccess();
  const dashboard = useCompanyDashboardAccess();
  const bankFeed = useCompanyBankFeedAccess();
  return useMemo(
    () => mapAccessInput(combineAccessInputs({ workspace, dashboard, bankFeed }), () => true),
    [workspace, dashboard, bankFeed],
  );
};
